import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
export interface SubscriptionOption {
  label: string;
  value: string;
  suffix: string;
  svg: string;
  maxSelected: number;
}

@Component({
    selector: 'subscription-options',
    templateUrl: './subscription-options.component.html',
    styleUrls: ['./subscription-options.component.scss'],
    standalone: false
})
export class SubscriptionOptionsComponent implements OnInit {
  @Input() productType: any = '';
  @Input() maxSelected: number | null = 1;
  @Input() subsciptionOptions: SubscriptionOption[];
  @Input() sessionConsultant: boolean;
  @Output() selectOptionEvent = new EventEmitter<SubscriptionOption>();
  constructor() {}

  ngOnInit(): void {}
  selectOption(option: SubscriptionOption) {
    this.selectOptionEvent.emit(option);
  }
}
